import { render, staticRenderFns } from "./DevamEdenGorevList.vue?vue&type=template&id=0d351e84&scoped=true"
import script from "./DevamEdenGorevList.vue?vue&type=script&lang=ts"
export * from "./DevamEdenGorevList.vue?vue&type=script&lang=ts"
import style0 from "./DevamEdenGorevList.vue?vue&type=style&index=0&id=0d351e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d351e84",
  null
  
)

export default component.exports